import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useFormik } from 'formik'
import { Password } from 'components/input_fields'
import { ChangePasswordSchema } from './ValidationSchema'
import { SaveButton } from 'components/buttons'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { changePassword } from '../../../../redux/slices/users'
import { toggleChangePasswordModal } from '../../../../redux/slices/globalSlice'
import { addUpdateHandler } from 'utils'
import { useTranslation } from 'react-i18next'

export default function ChangePasswordForm() {

    const [spinner, setSpinner] = useState(false)
    const [oldPassword, setOldPassword] = useState(false)
    const [newPassword, setNewPassword] = useState(false)
    const [confirmPassword, setConfirmPassword] = useState(false)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const initialValues = {
        old_password: '',
        new_password: '',
        confirm_password: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: ChangePasswordSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setSpinner(true)
            dispatch(changePassword({ 'values': values })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: `${t('profile.password')} ${t('profile.success_changed')}`,
                wrong_toast: `${t('common.wrong')}`,
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => {
                    dispatch(toggleChangePasswordModal());
                }
            }))
        },
    })

    return (
        <>
            <div className="container-fluid">
                <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} >
                    <div className="row">

                        <div className="col-lg-12">
                            <Password
                                label_name={t('profile.old_password')}
                                mandatory={true}
                                placeholder=''
                                disabled={false}
                                name='old_password'
                                value={values.old_password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.old_password && touched.old_password ? (<span className='field_error'>{errors.old_password}</span>) : null}
                                showPassword={oldPassword}
                                setShowPassword={setOldPassword}
                            />
                        </div>

                        <div className="col-lg-12">
                            <Password
                                label_name={t('profile.new_password')}
                                mandatory={true}
                                placeholder=''
                                disabled={false}
                                name='new_password'
                                value={values.new_password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.new_password && touched.new_password ? (<span className='field_error'>{errors.new_password}</span>) : null}
                                showPassword={newPassword}
                                setShowPassword={setNewPassword}
                            />
                        </div>

                        <div className="col-lg-12">
                            <Password
                                label_name={t('profile.confirm_password')}
                                mandatory={true}
                                placeholder=''
                                disabled={false}
                                name='confirm_password'
                                value={values.confirm_password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.confirm_password && touched.confirm_password ? (<span className='field_error'>{errors.confirm_password}</span>) : null}
                                showPassword={confirmPassword}
                                setShowPassword={setConfirmPassword}
                            />
                        </div>

                        <div className="col-lg-12">
                            <SaveButton
                                button_name={t('common.submit')}
                                spinner={spinner}
                            />
                        </div>

                    </div>
                </Form>
            </div>
        </>
    )
}